import { EyeoffIcon, EyeonIcon } from '@bfe/moly-icons';
import { useState } from 'react';

import SecurityComponent from '@/components/SecurityComponent';
import { showApiSecret } from '@/services/apiManagement';
import { IParentApiManagement } from '@/services/types/apiManagement';
import { SCENES } from '@/utils/securityComponent';
import { ViewApiSecretPwdErrorTrack } from '@/utils/trace-list/openApi';

const containerStyle = { display: 'flex', gap: '4px', alignItems: 'center' };

const EyeIcon = ({
  showSecret,
  onHandle,
}: {
  showSecret: boolean;
  onHandle: () => void;
}) => {
  const style = {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  };

  const color = '#81858c';

  if (showSecret) {
    return <EyeonIcon onClick={onHandle} style={style} color={color} />;
  }

  return <EyeoffIcon onClick={onHandle} style={style} color={color} />;
};

const SecretPwd = ({ record }: { record: IParentApiManagement }) => {
  const [showSecurityComponent, setShowSecurityComponent] = useState(false);
  const [secret, setSecret] = useState('');
  const [showSecret, setShowSecret] = useState(false);

  // 安全组件验证成功回调
  const onSecuritySuccess = (riskToken: string) => {
    // 调用接口获取密码
    showApiSecret({
      apikey: record.api_key,
      risk_token: riskToken,
    })
      .then((res) => {
        const { result } = (res as { result: { secret: string } }) || {};
        if (result?.secret) {
          // 设置
          setSecret(result.secret);
          setShowSecret(true);
        } else {
          // 错误上报：接口成功，但未返回secret
          ViewApiSecretPwdErrorTrack(res);
        }
      })
      .catch((error) => {
        // 错误上报：接口失败
        ViewApiSecretPwdErrorTrack(error);
      });
  };

  const onHandle = () => {
    if (showSecret) {
      // 已显示，则隐藏
      setShowSecret(false);
    } else if (!secret) {
      // 显示密码并且没有获取过密码时，先唤起安全组件
      setShowSecurityComponent(true);
    } else {
      // 已获取过密码，则直接展示
      setShowSecret(true);
    }
  };

  return (
    <>
      <div style={containerStyle}>
        <span
          title={record.secret as unknown as string}
          style={secret ? {} : { height: '16px' }}
        >
          {record.flag === 'rsa'
            ? '--'
            : showSecret
            ? secret || record.secret
            : record.secret}
        </span>
        {/* 托管商首次创建的API可以查看密钥密码 */}
        {record?.isCust && (
          <EyeIcon onHandle={onHandle} showSecret={showSecret} />
        )}
      </div>
      {/* 安全组件 */}
      {showSecurityComponent && (
        <SecurityComponent
          scene={SCENES.VIEW_API_SECRET_PWD}
          onSuccess={(risk_token) => {
            setShowSecurityComponent(false);
            onSecuritySuccess(risk_token);
          }}
          onClose={(riskTokenType, riskToken) => {
            // 如果安全组件下发了引导项，并且用户关闭了引导弹窗，也认为是校验成功
            if (riskTokenType === 'guide' && riskToken) {
              onSecuritySuccess(riskToken);
            }
            setShowSecurityComponent(false);
          }}
        />
      )}
    </>
  );
};

export default SecretPwd;
